import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Table from "../../../../core/common/dataTable/index";
import Toasts from "../../../../core/common/toast";
import { getWingDesignationDepartment } from "../../../../core/data/redux/wingDesignationDepartmentSlice";
import { all_routes } from "../../../router/all_routes";

const WingDesignationDepartment = () => {
  const dispatch = useDispatch();
  const wingDesignationDepartmentState = useSelector(
    (state: any) => state.wingDesignationDepartmentState
  );
  const routes = all_routes;

  const [dataList, setDataList] = useState<any[]>([]);
  const [searchParams, setSearchParams] = useState({
    wing: "",
    department: "",
    designation: "",
  });
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  // Debounce search (optional)
  const [debouncedParams, setDebouncedParams] = useState(searchParams);
  useEffect(() => {
    const delay = setTimeout(() => {
      setPagination((prev) => ({ ...prev, current: 1 }));
      setDebouncedParams(searchParams);
    }, 500);
    return () => clearTimeout(delay);
  }, [searchParams]);

  // Fetch from server
  const fetchRecords = () => {
    dispatch(
      getWingDesignationDepartment({
        page: pagination.current,
        limit: pagination.pageSize,
        wing: debouncedParams.wing,
        department_name: debouncedParams.department,
        designation_name: debouncedParams.designation,
      })
    );
  };

  useEffect(() => {
    fetchRecords();
  }, [pagination.current, pagination.pageSize, debouncedParams]);

  // Update list when redux updates
  useEffect(() => {
    const result = wingDesignationDepartmentState?.data?.data;
    if (result?.data?.length > 0) {
      setDataList(result.data);
      setPagination((prev) => ({
        ...prev,
        total: result.total || result.data.length,
        current: result.page || 1,
        pageSize: result.limit || 10,
      }));
    } else {
      setDataList([]);
    }
  }, [wingDesignationDepartmentState.loading]);

  // Table columns
  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "id",
      width: 80,
      render: (text: string, record: any, index: number) =>
        pagination.current
          ? index + (pagination.current - 1) * pagination.pageSize + 1
          : index + 1,
    },
    { title: "Wing", dataIndex: "wing_name" },
    { title: "Department", dataIndex: "department_name" },
    { title: "Designation", dataIndex: "designation_name" },
    { title: "Job", dataIndex: "job_name" },
    { title: "Designation ID", dataIndex: "designation_id" },
    { title: "Department ID", dataIndex: "department_id" },
    { title: "Job Key ID", dataIndex: "job_key_id" },
  ];

  const handlePagination = (paginationInfo: any) => {
    setPagination((prev) => ({
      ...prev,
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize,
    }));
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <h3 className="page-title mb-1">Designation & Department</h3>
          <nav>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to={routes.adminDashboard}>Dashboard</Link>
              </li>
              <li className="breadcrumb-item active">Designations & Departments</li>
            </ol>
          </nav>
        </div>

        <div className="card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
            <h4 className="mb-3">Designations & Departments</h4>
          </div>

          <div className="card-body p-0 py-3">


            {/* Table */}
            <Table
              columns={columns}
              dataSource={dataList}
              Selection={false}
              paginationConfig={pagination}
              handlePagination={handlePagination}
            >
              <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                <div>
                  
                  
                  <select
                    className="form-select"
                    value={searchParams.wing}
                    onChange={(e) =>
                      setSearchParams((prev) => ({ ...prev, wing: e.target.value }))
                    }
                    style={{ width: 180 }}
                  >
                    <option value="">Search by wing</option>
                    {['Maintenance','Projects','Operations'].map((item) => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Search by department"
                    value={searchParams.department}
                    onChange={(e) =>
                      setSearchParams((prev) => ({
                        ...prev,
                        department: e.target.value,
                      }))
                    }
                    style={{ width: 180 }}
                  />
                </div>
                <div>
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Search by designation"
                    value={searchParams.designation}
                    onChange={(e) =>
                      setSearchParams((prev) => ({
                        ...prev,
                        designation: e.target.value,
                      }))
                    }
                    style={{ width: 180 }}
                  />
                </div>
              </div>
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WingDesignationDepartment;
